export default {
    data() {
        return {
            pageSize: 10,
            currentPage: 1,
            sortOrder: 'ascending',
            defaultSortOrder: 'ascending'
        }
    },

    methods: {
        paginate(rows) {
            const trimStart = (this.currentPage - 1) * this.pageSize
            const trimEnd = trimStart + this.pageSize

            const sortOrder = this.sortOrder || this.defaultSortOrder
            if (sortOrder == 'descending') rows = [...rows].reverse()

            return rows.slice(trimStart, trimEnd)
        }
    }
}
